import type { NavbarGroupProps } from '@/business-components/navbar-group/NavbarGroup';
import {
  NavbarGroupLevel,
  NavbarGroupType,
} from '@/business-components/navbar-group/type/NavbarGroupTypeLevel';
import type { Navigation } from '@/shared/constant/navigation/Navigation';
import { NavigationTypeEnum } from '@/shared/constant/navigation/Navigation';
import React from 'react';

export function useLevelNavbarGroup(navigation: Navigation) {
  const firstLevelNavbarGroup = React.useMemo(() => {
    if (navigation.type === NavigationTypeEnum.None) {
      return undefined;
    }

    const result: NavbarGroupProps = {
      type: NavbarGroupType.Default,
      level: NavbarGroupLevel.Level1,
      items: navigation.firstLevelNavbarItems,
    };

    return result;
  }, [navigation]);

  const secondLevelNavbarGroup = React.useMemo(() => {
    if (navigation.type === NavigationTypeEnum.SecondLevelNavigation) {
      const result: NavbarGroupProps = {
        type: NavbarGroupType.LineTab,
        level: NavbarGroupLevel.Level2,
        items: navigation.secondLevelNavbarItems,
      };

      return result;
    } else if (navigation.type === NavigationTypeEnum.ThirdLevelNavigation) {
      const result: NavbarGroupProps = {
        type: NavbarGroupType.Select,
        level: NavbarGroupLevel.Level2,
        items: navigation.secondLevelNavbarItems,
      };

      return result;
    }
    return undefined;
  }, [navigation]);

  const thirdLevelNavbarGroup = React.useMemo(() => {
    if (navigation.type !== NavigationTypeEnum.ThirdLevelNavigation) {
      return undefined;
    }

    const result: NavbarGroupProps = {
      type: NavbarGroupType.LineTab,
      level: NavbarGroupLevel.Level3,
      items: navigation.thirdLevelNavbarItems,
    };

    return result;
  }, [navigation]);

  return {
    firstLevelNavbarGroup,
    secondLevelNavbarGroup,
    thirdLevelNavbarGroup,
  };
}
